import * as React from "react";
import { useTranslation } from 'react-i18next';

const RenderDetailQuestions = (props: any) => {
    const { t: tLang } = useTranslation();
    const handleAnswerSelection = (e: any) => {
        const { id } = e.target;
        let ans = {} as any;

        ans[id.split("_")[1]] = id.split("_")[2] === "yes";
        props.questions.AnswerSchema.forEach((ans: any) => {
            if (id.split("_")[1] === ans.Id) ans.answer = id.split("_")[2];
        });
        props.setAnswer(ans);
    };

    return (
        <React.Fragment>
            <p>
                <strong>{props.questions.Question}</strong>
            </p>
            <br />
            <div className="line-divider"></div>
            {props.questions.AnswerSchema.map((question: any, index: any) => (
                <div key={"answer-schema-" + index}>
                    <fieldset className="form-row inline padding-vertical-s">
                        <div className="row">
                            <div className="col-xs-12 col-sm-9 col-no-gutter margin-bottom-xs">
                                <legend className="legend-label">    <label className="form-radio-label" htmlFor={"question_" + question.Id + "_yes"}>{question.Title}</label></legend>
                                <p>{question.Details}</p>
                            </div>
                            <div className="col-xs-12 col-sm-3 col-no-gutter">
                                <div className="row between-xs">
                                    <div className="col-xs margin-right-s flex-grow-null col-no-gutter">
                                        <div className="form-row no-margin">
                                            <div className="form-input">
                                                <label className="form-radio-label" htmlFor={"question_" + question.Id + "_yes"}>
                                                    <input
                                                        type="radio"
                                                        id={"question_" + question.Id + "_yes"}
                                                        name={"question_" + question.Id}
                                                        onChange={(e) => handleAnswerSelection(e)}
                                                        defaultChecked={question.answer === "yes"}
                                                    />
                                                    <span className="form-radio-label-text">{tLang("resourcesSection.securityAssessmentTab.yesBtnText")}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs col-no-gutter">
                                        <div className="form-row no-margin">
                                            <div className="form-input">
                                                <label className="form-radio-label" htmlFor={"question_" + question.Id + "_no"}>
                                                    <input
                                                        type="radio"
                                                        id={"question_" + question.Id + "_no"}
                                                        name={"question_" + question.Id}
                                                        onChange={(e) => handleAnswerSelection(e)}
                                                        defaultChecked={question.answer === "no"}
                                                    />
                                                    <span className="form-radio-label-text">{tLang("resourcesSection.securityAssessmentTab.noBtnText")} / {tLang("resourcesSection.securityAssessmentTab.unsureBtnText")}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <div className="line-divider"></div>
                </div>
            ))}
        </React.Fragment>
    );
};

export default RenderDetailQuestions;
